// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { IResponseTypesSet, IRiskTemplate } from 'types/graphql'
// utils
import orderBy from 'lodash/orderBy'

export interface TemplatesState {
  data: IRiskTemplate[]
  loading: boolean
  responseTypes: IResponseTypesSet[]
}

const initialState: TemplatesState = {
  data: [],
  loading: false,
  responseTypes: []
}

export const riskTemplatesSlice = createSlice({
  name: Reducers.RISK_TEMPLATES,
  initialState,
  reducers: (create) => ({
    addRiskTemplate: create.reducer((state, action: PayloadAction<IRiskTemplate>) => {
      state.data = orderBy([...state.data, action.payload], 'name')
    }),
    setRiskTemplates: create.reducer((state, action: PayloadAction<IRiskTemplate[]>) => {
      state.data = action.payload
    }),
    updateRiskTemplate: create.reducer((state, action: PayloadAction<{ id: string; data: IRiskTemplate }>) => {
      state.data = orderBy(
        state.data.map((item) => {
          if (item.id === action.payload.id) {
            return { ...item, ...action.payload.data }
          }
          return item
        }),
        'name'
      )
    }),
    deleteRiskTemplate: create.reducer((state, action: PayloadAction<string>) => {
      state.data = state.data.filter((item) => item.id !== action.payload)
    }),
    setRiskTemplatesLoading: create.reducer((state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    }),
    setResponseTypes: create.reducer((state, action: PayloadAction<IResponseTypesSet[]>) => {
      state.responseTypes = action.payload
    })
  }),
  selectors: {
    responseTypesSelector: (state) => state.responseTypes,
    riskTemplatesSelector: (state) => state.data,
    riskTemplatesLoadingSelector: (state) => state.loading
  }
})

export const {
  addRiskTemplate,
  setResponseTypes,
  setRiskTemplates,
  updateRiskTemplate,
  deleteRiskTemplate,
  setRiskTemplatesLoading
} = riskTemplatesSlice.actions

export const { riskTemplatesSelector, riskTemplatesLoadingSelector, responseTypesSelector } =
  riskTemplatesSlice.selectors
